import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../product/style/categoryList.css';
import Breadcrumb from '../../Component/breadcrumb/Breadcrumb';
import PatternFilter from '../../Component/Layout/Filter/PatternFilter';
import SizeFilter from '../../Component/Layout/Filter/SizeFilter';
import ColorFilter from '../../Component/Layout/Filter/ColorFilter';
import AllFilter from '../../Component/Layout/Filter/AllFilter';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getproductlist } from './service/productlist.service';

const ProductList = () => {
  const [loading, setLoading] = useState(true);

  // Simulate data loading
  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Set loading state to false after 2 seconds
    }, 2000); 
  }, []);

  return (
    <>
      <Breadcrumb/>

      <section className="category-List">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-md-7 col-sm-6 col-12">
              <div className="Filterbg">
                <PatternFilter />
                <SizeFilter />
                <ColorFilter />
                <AllFilter />
              </div>
            </div>
            <div className="col-lg-3 col-md-5 col-sm-6 col-12">
              <div className="input-icon">
                <i className="bi bi-search font-sm"> </i>
                <input
                  type="text"
                  placeholder="Search..."
                  className="form-control form-control-sm bg-white input"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="category-List">
        <div className="container">
          <div className="row">
            {loading ? (
              // Skeleton Loader
              Array(8)
                .fill()
                .map((_, index) => (
                  <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div
                      className="border-1 p-2 mt-2 bg-gray-100"
                      style={{ borderRadius: '5px' }}
                    >
                      <div className="relative overflow-hidden mb-1">
                        <Skeleton height={200} width="100%" />
                      </div>
                      <div className="text-center mt-2">
                        <Skeleton width="60%" />
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              // Actual Content
              Array(8)
                .fill()
                .map((_, index) => (
                  <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-6">
                    <div
                      className="border-1 p-2 mt-2 bg-gray-100"
                      style={{ borderRadius: '5px' }}
                    >
                      <div className="relative overflow-hidden mb-1">
                        <Link to="/" className="block">
                          <img
                            src="https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2b-img/EnvogueImages/Quality/Abby/ABBY.jpg"
                            className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110 border-radius-13"
                            alt="Abby"
                          />
                        </Link>
                      </div>
                      <div className="text-center mt-2">
                        <Link
                          to="/"
                          className="text-gray-600 text-lg text-decoration-none"
                        >
                          ABBY
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductList;
